let imagesAssetFolder = process.env.NODE_ENV === 'production'
  ? 'https://www.straitstimes.com/multimedia/graphics/assets/'
  : 'https://st-graphics-dev-assets.s3-ap-southeast-1.amazonaws.com/'

imagesAssetFolder += 'images/sg-ge2020'

const prefix = 1 // ST's json index

const rootPath = process.env.NODE_ENV === 'production'
  ? 'https://www.straitstimes.com/multimedia/graphics/json/' + prefix + '/'
  : 'https://st-graphics-dev-json.s3-ap-southeast-1.amazonaws.com/'

// for qa.st-visuals.com
// const candidateNominationDayUrl = rootPath + '1sUttdL8duIUpGXMnk5mnX41EkTlb0q5Dzi1mwQilIK8/1453835185.json' // GE Candidate info - dev purpose

// for dev.st-visuals.com
const candidateNominationDayUrl = rootPath + '1sUttdL8duIUpGXMnk5mnX41EkTlb0q5Dzi1mwQilIK8/1621822693.json' // GE Candidate info - QC

const constituencyTypes = {
  1: 'SMC',
  3: 'Three-member GRC',
  4: 'Four-member GRC',
  5: 'Five-member GRC',
  6: 'Six-member GRC'
}

const partyNames = {
  WP: 'Workers\' Party',
  PAP: 'People\'s Action Party',
  RP: 'Reform Party',
  SPP: 'Singapore People\'s Party',
  SDP: 'Singapore Democratic Party',
  NSP: 'National Solidarity Party',
  SDA: 'Singapore Democratic Alliance',
  PPP: 'People\'s Power Party',
  PSP: 'Progress Singapore Party',
  PV: 'Peoples Voice',
  RDU: 'Red Dot United'
}

const partyColor = {
  PAP: '#d7445b',
  WP: '#499ED5',
  SDP: '#c768a6',
  NSP: '#f58340',
  RP: '#f8dd64',
  SPP: '#96c083',
  SDA: '#a5aab3',
  PPP: '#74c1c7',
  PSP: '#953932',
  PV: '#664C9B',
  RDU: '#CC5C3A',
  IND: '#5d6364'
}

const constituenciesInfo = {
  'Aljunied': {
    mp: 5,
    former_incumbant_party: 'WP'
  },
  'Ang Mo Kio': {
    mp: 5,
    former_incumbant_party: 'PAP'
  },
  'Bishan-Toa Payoh': {
    mp: 4,
    former_incumbant_party: 'PAP'
  },
  'Bukit Batok': {
    mp: 1,
    former_incumbant_party: 'PAP'
  },
  'Bukit Panjang': {
    mp: 1,
    former_incumbant_party: 'PAP'
  },
  'Chua Chu Kang': {
    mp: 4,
    former_incumbant_party: 'PAP'
  },
  'East Coast': {
    mp: 5,
    former_incumbant_party: 'PAP'
  },
  'Holland-Bukit Timah': {
    mp: 4,
    former_incumbant_party: 'PAP'
  },
  'Hong Kah North': {
    mp: 1,
    former_incumbant_party: 'PAP'
  },
  'Hougang': {
    mp: 1,
    former_incumbant_party: 'WP'
  },
  'Jalan Besar': {
    mp: 4,
    former_incumbant_party: 'PAP'
  },
  'Jurong': {
    mp: 5,
    former_incumbant_party: 'PAP'
  },
  'Kebun Baru': {
    mp: 1
  },
  'MacPherson': {
    mp: 1,
    former_incumbant_party: 'PAP'
  },
  'Marine Parade': {
    mp: 5,
    former_incumbant_party: 'PAP'
  },
  'Marsiling-Yew Tee': {
    mp: 4,
    former_incumbant_party: 'PAP'
  },
  'Marymount': {
    mp: 1
  },
  'Mountbatten': {
    mp: 1,
    former_incumbant_party: 'PAP'
  },
  'Nee Soon': {
    mp: 5,
    former_incumbant_party: 'PAP'
  },
  'Pasir Ris-Punggol': {
    mp: 5,
    former_incumbant_party: 'PAP'
  },
  'Pioneer': {
    mp: 1,
    former_incumbant_party: 'PAP'
  },
  'Potong Pasir': {
    mp: 1,
    former_incumbant_party: 'PAP'
  },
  'Punggol West': {
    mp: 1
  },
  'Radin Mas': {
    mp: 1,
    former_incumbant_party: 'PAP'
  },
  'Sembawang': {
    mp: 5,
    former_incumbant_party: 'PAP'
  },
  'Sengkang': {
    mp: 4
  },
  'Tampines': {
    mp: 5,
    former_incumbant_party: 'PAP'
  },
  'Tanjong Pagar': {
    mp: 5,
    former_incumbant_party: 'PAP'
  },
  'West Coast': {
    mp: 5,
    former_incumbant_party: 'PAP'
  },
  'Yio Chu Kang': {
    mp: 1
  },
  'Yuhua': {
    mp: 1,
    former_incumbant_party: 'PAP'
  }
}

export {imagesAssetFolder, candidateNominationDayUrl, constituenciesInfo, constituencyTypes, partyNames, partyColor}
